import { Component } from '@angular/core';

@Component({
  selector: 'app-college',
  templateUrl: './college.component.html',
})
export class CollegeComponent {}
